@if (entry?.base?.display) {
  <div>
    <section class="enroll-section-body">
      <div class="field-title">Qualifying Life Event</div>
      <div class="content-grey">{{lifeEvent}}</div>
      @if (sepReason) {
        <div>
          <div class="field-title">SEP REASON</div>
          <div class="content-grey">{{sepReason}}</div>
        </div>
      }
      @if (lifeEventDate) {
        <div class="field-title">Date of Life Event</div>
        <div class="content-grey">{{lifeEventDate}}</div>
      }
      <div class="field-title">Effective Date of Coverage</div>
      <div class="content-grey">{{effectiveDate}}</div>
    </section>
  </div>
}